import { memo } from 'react'
import EditAddressModal from '../../../features/account/components/account-address/_new/edit-address-modal'
import AddAddressModal from '../../../features/account/components/account-address/_new/add-address-modal'
import AccountExpiredModal from '../../../features/account/components/account-expired-modal'
import AddReviewOrderModal from '../../../features/orders/components/add-review-order-modal'
import FeedModal from '../../../features/feed/components/feed-modal'

const AppModalsWrapper = memo(() => {
  return (
    <>
      <AddAddressModal />
      <EditAddressModal />
      <AccountExpiredModal />

      {/* Reusable Review Order Modal */}
      <AddReviewOrderModal />

      <FeedModal />
    </>
  )
})

export default AppModalsWrapper
